import { render } from "./TaskCard.vue?vue&type=template&id=13f1d3da&scoped=true"
import script from "./TaskCard.vue?vue&type=script&lang=js"
export * from "./TaskCard.vue?vue&type=script&lang=js"

import "./TaskCard.vue?vue&type=style&index=0&id=13f1d3da&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-13f1d3da"

export default script